import {makeObservable, observable, runInAction} from "mobx";
import {message, notification} from "antd";
import Merchant from "@home/model/Merchant";
import {request} from "@/framework/network/request";


export default class MerchantRegStore {
  loading: boolean

  constructor() {
    makeObservable(this, {
      loading: observable,

    })
    this.loading = false;

  }


  // 保存商户
  saveMerchant = async (merchant: Merchant) => {
    try {
      this.loading = true
      const res = await request.post(`/register/merchant`, merchant)
      if (res.status === 1) {
        await message.success('申请成功', 2)
      } else {
        await message.error(res.msg === '商户已经存在')
      }
      runInAction(() => {
        this.loading = false
      })
    }catch (e) {
      this.loading = false
      notification.error({
        message: '获取商品信息错误',
        description: e.message
      })
    }
  }

}